export const popupStoreSearchCategories = [
  { value: 'name', label: '이름' },
  { value: 'address', label: '주소' },
];
